<!doctype html>
<html class="loading" lang="en" data-textdirection="ltr">
  <body
    class="vertical-layout vertical-menu 1-column menu-expanded"
    data-open="click"
    data-menu="vertical-menu"
    data-col="1-column">
    <link
      href="https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800;900&display=swap"
      rel="stylesheet" />

    <div class="app-content content">
      <div class="content-wrapper">
        <div class="content-header row"></div>
        <div class="content-body">
          <section class="flexbox-container">
            <div class="col-12 d-flex align-items-center justify-content-center">
              <div class="col-md-8 col-10 p-0 lef-10 lef-10" style="margin-top: 1%">
                <div class="slogan" style="padding-left: 26px">
                  <p class="text-slogan text-voce">VOCÊ</p>
                  <p class="text-slogan text-saudavel">SAUDÁVEL</p>
                  <p class="text-slogan text-saudavel">E SEGURO</p>
                  <p class="text-slogan text-voce">É A NOSSA</p>
                  <p class="text-slogan text-meta">META.</p>
                </div>
                <div class="card border-grey form-radius border-lighten-3 px-1 py-1 m-0">
                  <div class="card-header border-0">
                    <div class="card-title text-center">
                      <img
                        src="../../../../assets/app-assets/images/logo/logo-b-geia.png"
                        width="120"
                        alt="geia logo" />
                    </div>
                  </div>
                  <div class="card-content">
                    <h6 class="card-subtitle text-muted text-center font-small-3 pt-2">
                      <span>
                        <font style="vertical-align: inherit">
                          <font style="vertical-align: inherit">Informe a sua nova senha!</font>
                        </font>
                      </span>
                    </h6>
                    <div class="card-body">
                      <form
                        name="form"
                        (ngSubmit)="f.form.valid && onResetarSenha()"
                        #f="ngForm"
                        novalidate
                        class="form-horizontal">
                        <fieldset class="form-group position-relative has-icon-left">
                          <input
                            name="password"
                            [(ngModel)]="ResetarSenhaVM.password"
                            required
                            #password="ngModel"
                            [type]="showPassword ? 'text' : 'password'"
                            minlength="6"
                            class="form-control border-radius"
                            id="user-password"
                            placeholder="informe a senha" />
                          <div class="form-control-position">
                            <i
                              class="pointer font-medium-2"
                              [ngClass]="{'ft-eye': showPassword, 'ft-eye-off': !showPassword}"
                              aria-hidden="true"
                              (click)="showHidePassword()"></i>
                          </div>
                          <div class="text-center text-sm-center" role="alert" *ngIf="password.errors && f.submitted">
                            <div>
                              <label
                                *ngIf="password.errors['required']"
                                class="font-alert text-center card-title danger"
                                for="inputSuccess">
                                <strong>A senha é obrigatória!</strong>
                              </label>
                            </div>
                            <div>
                              <label
                                *ngIf="password.errors['minlength']"
                                class="font-alert text-center card-title danger"
                                for="inputSuccess">
                                <strong>A senha deve ter pelo menos 6 caracteres!</strong>
                              </label>
                            </div>
                          </div>
                        </fieldset>

                        <fieldset class="form-group position-relative has-icon-left">
                          <input
                            ngPreventCutCopyPaste
                            name="confirmPassword"
                            [(ngModel)]="ResetarSenhaVM.confirmPassword"
                            required
                            #confirmPassword="ngModel"
                            [type]="showPassword ? 'text' : 'password'"
                            minlength="6"
                            class="form-control border-radius"
                            id="user-password-confirme"
                            placeholder="Confirme a senha"
                            required />
                          <div class="form-control-position">
                            <i
                              class="pointer font-medium-2"
                              [ngClass]="{'ft-eye': showPassword, 'ft-eye-off': !showPassword}"
                              aria-hidden="true"
                              (click)="showHidePassword()"></i>
                          </div>
                          <div
                            class="text-center text-sm-center"
                            role="alert"
                            *ngIf="confirmPassword.errors && f.submitted">
                            <div>
                              <label
                                *ngIf="confirmPassword.errors['required']"
                                class="font-alert text-center card-title danger"
                                for="inputSuccess">
                                <strong>Campo obrigatório!</strong>
                              </label>
                            </div>
                            <div>
                              <label
                                *ngIf="confirmPassword.errors['minlength']"
                                class="font-alert text-center card-title danger"
                                for="inputSuccess">
                                <span><i class="fa fa-exclamation-circle pointer">Campo obrigatório!</i></span>
                              </label>
                            </div>
                          </div>
                          <div class="mt-1 justify-content-center">
                            <app-captcha #captcha (tokenChange)="captchaToken = $event"></app-captcha>
                          </div>
                        </fieldset>

                        <button
                          [disabled]="!captchaToken"
                          class="btn btn-round btn-info white btn-min-width box-shadow-3 btn-block">
                          <i class="ft-unlock"></i>
                          Alterar Senha
                        </button>
                      </form>
                    </div>
                    <div class="card-footer border-0">
                      <p class="float-sm-left text-center">
                        <a href="javascript:void(0)" (click)="onRedirectLogin()" class="card-link">Login</a>
                      </p>
                      <!-- <p class="float-sm-right text-center">
                        Novo Usuário?
                        <span></span>
                        <a href="javascript:void(0)" (click)="onRedirectCadastro()" class="card-link">Criar Conta</a>
                      </p> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </body>
</html>
